import { Pivot, PivotItem } from '@fluentui/react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import '../../../css/components/products.scss';
import useToken from '../../account/login/useToken';
import ComponentModels from './models';
import ComponentVendors from './componentVendors';
import Brand from './brand';
const Components = () => {
  const { userTokenInfo } = useToken();
  const { t } = useTranslation();
  return (
    <>
      {(userTokenInfo.Role !== 'Vendor' && (
        <Pivot className="tab-header">

          <PivotItem headerText={t('Component')} itemKey="Component">
            <ComponentVendors></ComponentVendors>
          </PivotItem>

          <PivotItem headerText={t('Brand')} itemKey="Brand">
            <Brand></Brand>
          </PivotItem>

          <PivotItem headerText={t('Model')} itemKey="Model">
            <ComponentModels></ComponentModels>
          </PivotItem>

        </Pivot>
      )) || (
        <Pivot className="tab-header">
          <PivotItem headerText={t('Component')} itemKey="Component">
            <ComponentVendors></ComponentVendors>
          </PivotItem>
        </Pivot>
      )}
    </>
  );
};
export default Components;
